// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/TailorDateField/Events.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {TailorDateField} from '@sail/ui';

export const Events = () => {
  return (
    <TailorDateField
      label="Date of birth"
      description="Enter your birthday"
      onFocus={(e) => {
        // eslint-disable-next-line no-console
        console.log('focus', e);
      }}
      onBlur={(e) => {
        // eslint-disable-next-line no-console
        console.log('blur', e);
      }}
      onKeyPress={(e) => {
        // eslint-disable-next-line no-console
        console.log('keypress', e);
      }}
      onKeyDown={(e) => {
        // eslint-disable-next-line no-console
        console.log('keydown', e);
      }}
      onKeyUp={(e) => {
        // eslint-disable-next-line no-console
        console.log('keyup', e);
      }}
    />
  );
};
